export const GET_PURCHASERECONCILIATION = "GET_PURCHASERECONCILIATION"
export const GET_STATE_LOADING = "GET_STATE_LOADING"
export const GET_CHANGESTATE_LIST_TYPE_STATE = "GET_CHANGESTATE_LIST_TYPE_STATE"